import { render } from "./CustomMultiselect.vue?vue&type=template&id=4c91a9e4&scoped=true"
import script from "./CustomMultiselect.vue?vue&type=script&lang=js"
export * from "./CustomMultiselect.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./CustomMultiselect.vue?vue&type=style&index=1&id=4c91a9e4&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c91a9e4"]])

export default __exports__